// import { FirebaseAnalytics } from '@capacitor-firebase/analytics';
import { initializeApp } from 'firebase/app';
import { Capacitor } from '@capacitor/core';
import { Component, ComponentInterface, Host, State, h } from '@stencil/core';
import { Persistor } from 'redux-persist';

import { firebaseConfig } from '../../config';
import storage from '../../services/storage';
import { persistor } from '../../store/index';

@Component({
  tag: 'app-persist-gate'
})
export class PersistGate implements ComponentInterface {

  @State() bootstrapped = false;
  unsubscribe: () => void;
  private pers: Persistor;
  private isWeb: boolean;

  async componentWillLoad() {
    this.isWeb = Capacitor.getPlatform() === 'web';
    if (this.isWeb) {
      initializeApp(firebaseConfig);
      // await FirebaseAnalytics.initializeFirebase(firebaseConfig);
    }

    await storage.init();

    this.pers = persistor();
    this.unsubscribe = this.pers.subscribe(() => this.handlePersistorState());
    this.handlePersistorState();
  }

  handlePersistorState() {
    const { bootstrapped } = this.pers.getState();
    this.bootstrapped = bootstrapped;
    if (this.bootstrapped && this.unsubscribe) {
      this.unsubscribe();
    }
  }

  disconnectedCallback() {
    this.unsubscribe();
  }

  render() {
    return <Host>
      {this.isWeb ? <jeep-sqlite></jeep-sqlite> : null}
      {this.bootstrapped ? <app-root /> : null}
    </Host>
  }
}
